<template>
    <client-page>
        <section class="section">
            <v-container>
                <template v-if="program?._id">
                    <expo-program-dashboard />
                </template>
                <v-fade-transition>
                    <v-overlay v-show="loading" :dark="false" color="white">
                        <v-progress-circular indeterminate size="100" width="5" color="primary" />
                    </v-overlay>
                </v-fade-transition>
            </v-container>
        </section>
    </client-page>
</template>

<script>
import { mapActions, mapState } from "vuex";

import ClientPage from "@/pages/client/templates/ClientPage.vue";
import ExpoProgramDashboard from "@/components/client/expo/programs/expo-program-dashboard.vue";

export default {
    components: {
        ClientPage,
        ExpoProgramDashboard,
    },
    props: {
        _program: { type: String },
    },
    data: () => ({
        loading: false,
    }),
    computed: {
        ...mapState("expo", ["program"]),
    },
    methods: {
        ...mapActions("expo", {
            initExpo: "init",
        }),
        async init() {
            let { _program } = this;
            if (!_program) return;

            this.loading = true;
            try {
                const { program } = await this.initExpo({ _program });
                if (!program) {
                    alert("해당 프로그램을 찾을 수 없습니다.");
                    throw this.$router.replace("/");
                }
            } finally {
                if (this.loading) this.loading = false;
            }
        },
    },
    watch: {
        _program() {
            this.init();
        },
    },
    mounted() {
        this.init();
    },
};
</script>

<style></style>
